import { FC, useState, createContext, ReactNode } from 'react';
type SidebarContextType = {
  sidebarToggle: any;
  toggleSidebar: () => void;
  closeSidebar: () => void;
};

export const SidebarContext = createContext<SidebarContextType>(
  {} as SidebarContextType
);

export const SidebarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  // Hidden by default on mobile; visible on md+ by default
  const getDefault = () => (typeof window !== 'undefined' ? window.innerWidth < 900 /* md breakpoint */ : true);
  const [sidebarToggle, setSidebarToggle] = useState<boolean>(getDefault());
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };

  return (
    <SidebarContext.Provider
      value={{ sidebarToggle, toggleSidebar, closeSidebar }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
